import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/warning-red.svg'


const _hoisted_1 = { class: "text-[#898790] text-base leading-[26px] tracking-[0.01rem] font-medium pb-[6px]" }
const _hoisted_2 = ["placeholder"]
const _hoisted_3 = {
  key: 0,
  class: "flex gap-1 items-center"
}
const _hoisted_4 = { class: "text-[#ed857f] text-sm" }



type Props = {
  title?: string;
  placeholder?: string;
  isError?: boolean;
  errorMessage?: string;
  height?: string;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'QuestionnaireTextArea',
  props: /*@__PURE__*/_mergeModels({
    title: {},
    placeholder: {},
    isError: { type: Boolean },
    errorMessage: {},
    height: {}
  }, {
    "modelValue": { required: true },
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any) {



const textModel = _useModel<string>(__props, "modelValue");

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", null, [
      _createElementVNode("h4", _hoisted_1, _toDisplayString(__props.title), 1),
      _withDirectives(_createElementVNode("textarea", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((textModel).value = $event)),
        placeholder: __props.placeholder,
        class: _normalizeClass(["p-3 mb-1 rounded-primary-radius border resize-none w-full outline-none bg-[#F9F8F6] text-black text-base leading-[26px] tracking-[0.01rem] font-medium placeholder:text-[#898790]", `${__props.height ? __props.height : 'h-[108px]'}
          ${__props.isError ? 'border-[#ED857F]' : ''} 
          ${!__props.isError && !textModel.value ? 'border-[#E3E1EA]' : ''} 
          ${textModel.value && textModel.value.length > 0 ? 'border-[#393840]' : ''} `])
      }, null, 10, _hoisted_2), [
        [_vModelText, textModel.value]
      ]),
      (__props.isError)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _cache[1] || (_cache[1] = _createElementVNode("img", {
              src: _imports_0,
              alt: "Warning"
            }, null, -1)),
            _createElementVNode("span", _hoisted_4, _toDisplayString(__props.errorMessage), 1)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})